import { CheckIcon } from '@/assets/icons';
import { PREMIUM_PERKS } from '@/constants/perks';
import styles from './PerksList.module.scss';

export function PerksList() {
  return (
    <div>
      {PREMIUM_PERKS.map((perk) => (
        <div key={perk} className={styles.row}>
          <CheckIcon size={17} className={styles.icon} />
          <span className={styles.text}>{perk}</span>
        </div>
      ))}
    </div>
  );
}
